import { get } from '@/redux/requests/api.js';
import normalizeRequestFailure from '@/redux/requests/lib/normalizeRequestFailure.js';

/* Pieve always receives the existing shown-on-Pieve metadata variant with hidden and whitelist
   values. Every display surface applies isPieveAppVisible with its own trusted viewer context. */
const listAppsMetadata = ({ signal, etag = null } = {}, callback) => {
  const normalizedEtag = String(etag || '').trim();

  return get('/v1/apps/metadata', {
    authToken: false,
    callback,
    headers: normalizedEtag
      ? {
          'If-None-Match': normalizedEtag
        }
      : undefined,
    loader: 'listAppsMetadata',
    query: { hidden: true, pieve: true, useCache: true },
    signal,
    onResponse: (responseShape) => {
      if (responseShape?.status === 304) {
        return {
          ...responseShape,
          data: {
            success: true,
            data: {
              notModified: true,
              etag: responseShape?.responseHeaders?.etag || normalizedEtag
            }
          }
        };
      }

      const nextResponseShape = normalizeRequestFailure({
        responseShape,
        fallbackMessage: 'Failed to load apps metadata'
      });

      if (nextResponseShape?.data?.success !== true) {
        return nextResponseShape;
      }

      return {
        ...nextResponseShape,
        data: {
          success: true,
          data: {
            items: Array.isArray(nextResponseShape?.data?.data) ? nextResponseShape.data.data : [],
            etag: nextResponseShape?.responseHeaders?.etag || null,
            notModified: false
          }
        }
      };
    }
  });
};

export default listAppsMetadata;
